import * as React from "react";
import { useTranslation } from 'react-i18next';

export const useFontFillAllConfig = () => {
    const { t } = useTranslation();
    
    return {
        config: { columns: 1 },
        fields: [
            {
                name: "value",
                label: t("common.fill_all_with_value"),
                type: "number",
                column: 1,
            }
        ]
    };
};

export default useFontFillAllConfig;
